(function () {
  'use strict';

  var routes = (window.DEMC && window.DEMC.routes) || { cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' };
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  /* Drawers (menu + cart) */
  var lastFocus = null;
  function openDrawer(id) {
    var drawer = document.getElementById(id);
    if (!drawer) return false;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    var close = $('[data-drawer-close]:not(.drawer__scrim)', drawer);
    if (close) close.focus();
    return true;
  }
  function closeDrawers() {
    $$('.drawer.is-open').forEach(function (d) {
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
    });
    document.documentElement.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      if (openDrawer(opener.getAttribute('data-drawer-open'))) e.preventDefault();
      return;
    }
    if (e.target.closest('[data-drawer-close]')) { closeDrawers(); return; }

    // Close desktop dropdowns when clicking elsewhere
    $$('.nav-dd[open]').forEach(function (dd) { if (!dd.contains(e.target)) dd.removeAttribute('open'); });

    var qtyBtn = e.target.closest('[data-qty-step]');
    if (qtyBtn) {
      var input = $('input', qtyBtn.closest('.qty'));
      var next = Math.max(parseInt(input.min || '0', 10), (parseInt(input.value, 10) || 0) + parseInt(qtyBtn.getAttribute('data-qty-step'), 10));
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    var remove = e.target.closest('[data-cart-remove]');
    if (remove) { e.preventDefault(); changeLine(remove.getAttribute('data-cart-remove'), 0, remove); return; }

    var arrow = e.target.closest('[data-carousel-prev], [data-carousel-next]');
    if (arrow) {
      var track = $('[data-carousel-track]', arrow.closest('[data-carousel]'));
      var dir = arrow.hasAttribute('data-carousel-next') ? 1 : -1;
      track.scrollBy({ left: dir * track.clientWidth * 0.8, behavior: 'smooth' });
      return;
    }

    var thumb = e.target.closest('[data-thumb]');
    if (thumb) {
      var main = $('[data-product-image]');
      if (main) { main.src = thumb.getAttribute('data-thumb'); main.removeAttribute('srcset'); }
      $$('[data-thumb]').forEach(function (t) { t.setAttribute('aria-current', t === thumb ? 'true' : 'false'); });
    }
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawers(); });

  /* Cart */
  function refreshCart(open) {
    var drawer = document.getElementById('cart-drawer');
    return fetch(routes.cart + '?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById('cart-drawer');
        if (drawer && fresh) {
          $('.drawer__panel', drawer).innerHTML = $('.drawer__panel', fresh).innerHTML;
          var count = fresh.getAttribute('data-count');
          $$('[data-cart-count]').forEach(function (el) { el.textContent = count; });
        }
        if (open) openDrawer('cart-drawer');
      });
  }

  window.DEMC = window.DEMC || {}; window.DEMC.refreshCart = refreshCart;

  function changeLine(key, quantity, el) {
    var wrap = el && el.closest('.cart-items');
    if (wrap) wrap.classList.add('is-loading');
    var row = el && el.closest('.cart-item');
    var keys = row && row.getAttribute('data-keys') ? row.getAttribute('data-keys').split(',') : [];
    var url = routes.cartChange + '.js', body = { id: key, quantity: quantity };
    if (keys.length > 1) {
      var updates = {};
      keys.forEach(function (k, i) { updates[k] = i === 0 ? quantity : 0; });
      url = routes.cartChange.replace(/change$/, 'update') + '.js';
      body = { updates: updates };
    }
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function () {
      if (document.body.classList.contains('template-cart')) window.location.reload();
      else return refreshCart(false);
    }).catch(function () { window.location.href = routes.cart; });
  }

  document.addEventListener('change', function (e) {
    var line = e.target.closest('[data-cart-qty]');
    if (line) { changeLine(line.getAttribute('data-cart-qty'), parseInt(line.value, 10) || 0, line); return; }

    var form = e.target.closest('[data-product]');
    if (form && e.target.matches('[data-option]')) updateVariant(form);
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('form[action$="/cart/add"]') || !document.getElementById('cart-drawer')) return;
    e.preventDefault();
    var btn = $('[type="submit"]', form);
    if (btn) btn.setAttribute('aria-disabled', 'true');
    fetch(routes.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return refreshCart(true); })
      .catch(function () { form.submit(); })
      .then(function () { if (btn) btn.removeAttribute('aria-disabled'); });
  });

  /* Product variants */
  function updateVariant(root) {
    var data = $('[data-variants]', root);
    if (!data) return;
    var variants = JSON.parse(data.textContent);
    var chosen = $$('[data-option]:checked', root).map(function (i) { return i.value; });
    var match = variants.filter(function (v) {
      return v.options.every(function (o, i) { return o === chosen[i]; });
    })[0];
    var btn = $('[data-add]', root);
    var idInput = $('input[name="id"]', root);
    if (!match) {
      btn.disabled = true;
      btn.textContent = btn.getAttribute('data-unavailable');
      return;
    }
    idInput.value = match.id;
    btn.disabled = !match.available;
    btn.textContent = btn.getAttribute(match.available ? 'data-label' : 'data-sold-out');
    $$('[data-price-for]', root).forEach(function (el) { el.hidden = el.getAttribute('data-price-for') !== String(match.id); });
    if (window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url);
    }
  }

  /* Scent tabs: one panel visible at a time, arrow keys move between tabs */
  $$('[data-tabs]').forEach(function (root) {
    var tabs = $$('[role="tab"]', root), panels = $$('[role="tabpanel"]', root);
    function select(i) {
      tabs.forEach(function (t, j) { t.setAttribute('aria-selected', j === i ? 'true' : 'false'); t.tabIndex = j === i ? 0 : -1; });
      panels.forEach(function (p, j) { p.hidden = j !== i; });
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(i); });
      t.addEventListener('keydown', function (e) {
        var n = e.key === 'ArrowRight' ? i + 1 : e.key === 'ArrowLeft' ? i - 1 : null;
        if (n === null) return;
        n = (n + tabs.length) % tabs.length; select(n); tabs[n].focus(); e.preventDefault();
      });
    });
    select(0);
  });

  /* Hero slideshow: swipe, arrows, dots, optional auto-advance; marks the active slide for entrance animations */
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  $$('[data-slider]').forEach(function (root) {
    var track = $('[data-track]', root), slides = $$('[data-slide]', root), dots = $$('[data-dot]', root);
    if (!track || !slides.length) return;
    var cur = 0, paused = false, inview = true;
    function mark() {
      dots.forEach(function (d, i) { d.setAttribute('aria-current', i === cur ? 'true' : 'false'); });
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === cur); });
    }
    function go(i) { cur = (i + slides.length) % slides.length; track.scrollTo({ left: slides[cur].offsetLeft - track.offsetLeft, behavior: reduced ? 'auto' : 'smooth' }); mark(); }
    var prev = $('[data-prev]', root), next = $('[data-next]', root);
    if (prev) prev.addEventListener('click', function () { go(cur - 1); });
    if (next) next.addEventListener('click', function () { go(cur + 1); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { cur = slides.indexOf(e.target); mark(); } }); }, { root: track, threshold: 0.6 });
      slides.forEach(function (s) { io.observe(s); });
      new IntersectionObserver(function (es) { inview = es[0].isIntersecting; }, { threshold: 0.2 }).observe(root);
    }
    mark();
    window.addEventListener('resize', function () { track.style.scrollBehavior = 'auto'; track.scrollLeft = slides[cur].offsetLeft - track.offsetLeft; track.style.scrollBehavior = ''; });
    if (root.getAttribute('data-autoplay') === 'true' && !reduced && slides.length > 1) {
      var ms = (parseInt(root.getAttribute('data-interval'), 10) || 7) * 1000;
      setInterval(function () { if (!paused && inview && !document.hidden) go(cur + 1); }, ms);
      ['pointerenter', 'focusin', 'touchstart'].forEach(function (ev) { root.addEventListener(ev, function () { paused = true; }, { passive: true }); });
      ['pointerleave', 'focusout'].forEach(function (ev) { root.addEventListener(ev, function () { paused = false; }); });
      root.addEventListener('touchend', function () { setTimeout(function () { paused = false; }, 9000); }, { passive: true });
    }
  });

  /* Spinning candles: crossfade through the photos, move the section colour with the candle, and show that candle's click icons */
  $$('[data-spin]').forEach(function (root) {
    var items = $$('[data-spin-item]', root), labels = $$('[data-spin-label]', root), hints = $$('[data-spin-hint]', sec = root.closest('[data-spinsec]')), sec = root.closest('[data-spinsec]'), hots = $$('[data-hot]', sec), i = 0, timer = null, fixed = sec.getAttribute('data-bgmode') === 'fixed';
    function closeAll() { hots.forEach(function (h) { h.classList.remove('is-open'); var b = $('[data-hot-btn]', h); if (b) b.setAttribute('aria-expanded', 'false'); }); run(); }
    function show(n) {
      closeAll();
      items[i].classList.remove('is-on'); if (labels[i]) labels[i].classList.remove('is-on'); if (hints[i]) hints[i].classList.remove('is-on');
      i = (n + items.length) % items.length;
      items[i].classList.add('is-on'); if (labels[i]) labels[i].classList.add('is-on'); if (hints[i]) hints[i].classList.add('is-on');
      hots.forEach(function (h) { h.classList.toggle('is-on', +h.getAttribute('data-candle') === i + 1); });
      if (!fixed) { var bg = items[i].getAttribute('data-bg'), ink = items[i].getAttribute('data-ink'); if (bg) sec.style.setProperty('--spin-bg', bg); if (ink) sec.style.setProperty('--spin-ink', ink); }
    }
    function run() { clearInterval(timer); if (!reduced && items.length > 1 && !sec.querySelector('.hot.is-open')) timer = setInterval(function () { show(i + 1); }, 4200); }
    hots.forEach(function (h) {
      var b = $('[data-hot-btn]', h), card = $('.hot__card', h);
      b.addEventListener('click', function (e) {
        e.stopPropagation();
        var was = h.classList.contains('is-open');
        hots.forEach(function (o) { o.classList.remove('is-open'); var ob = $('[data-hot-btn]', o); if (ob) ob.setAttribute('aria-expanded', 'false'); });
        if (was) { run(); return; }
        h.style.setProperty('--shift', '0px'); h.classList.remove('hot--up');
        var st = sec.querySelector('.spinsec__stage').getBoundingClientRect(), hr = h.getBoundingClientRect();
        if (hr.top - st.top > st.height * 0.55) h.classList.add('hot--up');
        h.classList.add('is-open'); b.setAttribute('aria-expanded', 'true'); clearInterval(timer);
        var r = card.getBoundingClientRect(), pad = 12, shift = 0;
        if (r.left < pad) shift = pad - r.left; else if (r.right > innerWidth - pad) shift = innerWidth - pad - r.right;
        h.style.setProperty('--shift', shift + 'px');
      });
    });
    document.addEventListener('click', function (e) { if (!e.target.closest('[data-hot]') && sec.querySelector('.hot.is-open')) closeAll(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
    root.addEventListener('click', function () { show(i + 1); });
    run();
  });
  /* Candle cards: the scent button opens that candle's notes and story */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-smell]'); if (!b) return;
    var panel = b.nextElementSibling, open = b.getAttribute('aria-expanded') === 'true';
    b.setAttribute('aria-expanded', open ? 'false' : 'true');
    if (open) panel.setAttribute('hidden', ''); else panel.removeAttribute('hidden');
  });

  /* Candle cards: arrows and dots for the swipe row on phones, one small nudge to show it moves */
  $$('[data-cc]').forEach(function (sec) {
    var track = $('[data-cc-track]', sec), dots = $$('[data-cc-dot]', sec), cards = $$('.cc__card', track);
    if (!track || !cards.length) return;
    function step() { return cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : track.clientWidth; }
    function cur() { return Math.max(0, Math.min(cards.length - 1, Math.round(track.scrollLeft / step()))); }
    function mark() { var c = cur(); dots.forEach(function (d, i) { if (i === c) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); }); }
    function go(i) { i = Math.max(0, Math.min(cards.length - 1, i)); track.scrollTo({ left: i * step(), behavior: reduced ? 'auto' : 'smooth' }); }
    track.addEventListener('scroll', mark, { passive: true }); window.addEventListener('resize', mark); mark();
    var pv = $('[data-cc-prev]', sec), nx = $('[data-cc-next]', sec);
    if (pv) pv.addEventListener('click', function () { go(cur() - 1); });
    if (nx) nx.addEventListener('click', function () { go(cur() + 1); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); });
    if (!reduced && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) {
        if (!en[0].isIntersecting) return; io.disconnect();
        if (track.scrollWidth <= track.clientWidth + 4 || track.scrollLeft > 0) return;
        setTimeout(function () { track.scrollTo({ left: 70, behavior: 'smooth' }); setTimeout(function () { if (track.scrollLeft < 140) track.scrollTo({ left: 0, behavior: 'smooth' }); }, 700); }, 500);
      }, { threshold: 0.6 });
      io.observe(track);
    }
  });

  /* Triple or double pour: the round candle buttons swap the candle, gradient, whisper and links */
  $$('[data-pour]').forEach(function (sec) {
    var tabs = $$('[data-pour-tab]', sec);
    function pick(n) {
      tabs.forEach(function (t, i) { t.classList.toggle('is-on', i === n); t.setAttribute('aria-selected', i === n ? 'true' : 'false'); });
      $$('[data-pour-bg]', sec).forEach(function (el, i) { el.classList.toggle('is-on', i === n); });
      $$('[data-pour-duo]', sec).forEach(function (el, i) { el.classList.toggle('is-on', i === n); if (i === n) { sec.style.setProperty('--pour-head', el.getAttribute('data-head')); sec.style.setProperty('--pour-body', el.getAttribute('data-body')); sec.style.setProperty('--arrow-c', el.getAttribute('data-note')); } });
      $$('[data-pour-say],[data-pour-shop]', sec).forEach(function (el) { el.classList.toggle('is-on', +el.getAttribute('data-i') === n); });
    }
    tabs.forEach(function (t, i) { t.addEventListener('click', function () { pick(i); }); });
  });

  /* Us vs them: the switch swaps sides */
  $$('[data-vs]').forEach(function (sec) {
    $$('[data-vs-side]', sec).forEach(function (b) {
      b.addEventListener('click', function () {
        sec.setAttribute('data-side', b.getAttribute('data-vs-side'));
        $$('[data-vs-side]', sec).forEach(function (o) { var on = o === b; o.classList.toggle('is-on', on); o.setAttribute('aria-selected', on ? 'true' : 'false'); });
      });
    });
  });

  /* Us vs them: the right side cycles through the five candles */
  $$('[data-vs]').forEach(function (sec) {
    var lists = [$$('[data-vs-bg]', sec), $$('[data-vs-duo]', sec), $$('[data-vs-girl]', sec)], n = lists[0].length, i = 0;
    if (n < 2 || reduced) return;
    setInterval(function () { i = (i + 1) % n; lists.forEach(function (l) { l.forEach(function (el, k) { el.classList.toggle('is-on', k === i); }); }); }, 4500);
  });

  /* Bundles: every card swaps to the next candle pair at the same moment (calmer than staggered), slowly */
  var bunI = 0;
  function bunPaint() {
    $$('[data-bun]').forEach(function (card) {
      var imgs = $$('[data-bun-img]', card), lab = $('[data-bun-label]', card); if (!imgs.length) return;
      var i = bunI % imgs.length;
      imgs.forEach(function (im, k) { im.classList.toggle('is-on', k === i); });
      if (lab) lab.textContent = imgs[i].getAttribute('data-label');
    });
  }
  bunPaint();
  if (!reduced) setInterval(function () { if (document.hidden) return; bunI++; bunPaint(); }, 3600);

  /* Proof in the wax: the top view cycles through the candles and the section colour follows */
  $$('[data-proof]').forEach(function (sec) {
    var imgs = $$('[data-pf-img]', sec), fr = $$('[data-pf-fruit]', sec), i = 0;
    if (imgs.length < 2 || reduced) return;
    setInterval(function () {
      imgs[i].classList.remove('is-on'); if (fr[i]) fr[i].classList.remove('is-on');
      i = (i + 1) % imgs.length;
      imgs[i].classList.add('is-on'); if (fr[i]) fr[i].classList.add('is-on');
      sec.style.setProperty('--pf-bg', imgs[i].getAttribute('data-bg')); sec.style.setProperty('--pf-ink', imgs[i].getAttribute('data-ink')); sec.style.setProperty('--pf-line', imgs[i].getAttribute('data-line'));
    }, 4200);
  });

  /* FAQ cards: flip on desktop, popup on phones */
  var fq = window.matchMedia ? window.matchMedia('(max-width: 699px)') : { matches: false };
  function closeFaq() { $$('[data-fmodal]').forEach(function (m) { m.setAttribute('hidden', ''); }); document.documentElement.style.overflow = ''; if (lastFaq) { lastFaq.focus(); lastFaq = null; } }
  var lastFaq = null;
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-fmodal-close]')) { closeFaq(); return; }
    var b = e.target.closest('.fcard__btn'); if (!b) return;
    var card = b.closest('[data-fcard]');
    if (fq.matches) {
      var sec = card.closest('.faq'), m = $('[data-fmodal]', sec);
      $('[data-fmodal-q]', m).textContent = $('.fcard__q', card).textContent;
      $('[data-fmodal-a]', m).textContent = $('.fcard__a', card).textContent;
      m.removeAttribute('hidden'); document.documentElement.style.overflow = 'hidden'; lastFaq = b; $('.fmodal__x', m).focus();
      return;
    }
    var on = card.classList.toggle('is-flipped');
    b.setAttribute('aria-expanded', on ? 'true' : 'false');
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeFaq(); });


  /* Reviews: the stack flips through on its own, arrows and swipe work too */
  $$('[data-rev]').forEach(function (sec) {
    var cards = $$('[data-rev-card]', sec), n = cards.length, cur = 0, timer = null, secs = parseFloat(getComputedStyle(sec).getPropertyValue('--rv-secs')) || 6;
    if (!n) return;
    function paint() { cards.forEach(function (c, i) { var d = (i - cur + n) % n; c.setAttribute('data-pos', d < 4 ? String(d) : (d === n - 1 ? 'out' : 'x')); c.setAttribute('aria-hidden', d === 0 ? 'false' : 'true'); }); }
    function go(k) { cur = (k + n) % n; paint(); }
    function run() { clearInterval(timer); if (!reduced && n > 1) timer = setInterval(function () { go(cur + 1); }, secs * 1000); }
    paint(); run();
    var pv = $('[data-rev-prev]', sec), nx = $('[data-rev-next]', sec), st = $('[data-rev-stack]', sec);
    if (pv) pv.addEventListener('click', function () { go(cur - 1); run(); });
    if (nx) nx.addEventListener('click', function () { go(cur + 1); run(); });
    sec.addEventListener('mouseenter', function () { clearInterval(timer); }); sec.addEventListener('mouseleave', run);
    var x0 = null;
    st.addEventListener('pointerdown', function (e) { x0 = e.clientX; });
    st.addEventListener('pointerup', function (e) { if (x0 === null) return; var dx = e.clientX - x0; x0 = null; if (Math.abs(dx) > 40) { go(cur + (dx < 0 ? 1 : -1)); run(); } });
  });

})();
